module.exports = __webpack_public_path__ + "static/img/pt.2ea9307.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sdwan/pt.png
// module id = GXYX
// module chunks = 0